module.exports = "<p>\n  pricing works!\n</p>\n"